// extracted by mini-css-extract-plugin
module.exports = {"downloadCodeContainer":"QRCodeDownload_downloadCodeContainer__JKBH2","storeBadgeContainer":"QRCodeDownload_storeBadgeContainer__Ly_Q7"};